import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { UAParser } from 'ua-parser-js';
import { getCookie } from '@miro-site/core';
export var getNetworkPayload = function getNetworkPayload() {
  var _window$navigator$con, _window$navigator$con2;

  return {
    connection_save_data: (_window$navigator$con = window.navigator.connection) === null || _window$navigator$con === void 0 ? void 0 : _window$navigator$con.saveData,
    connection_speed_type: (_window$navigator$con2 = window.navigator.connection) === null || _window$navigator$con2 === void 0 ? void 0 : _window$navigator$con2.effectiveType
  };
};
export var getGeoDataPayload = function getGeoDataPayload() {
  var geoDataString = getCookie('geo_data');

  if (!geoDataString) {
    return {};
  }

  var geoDataParts = geoDataString.split('|');
  return {
    geo_country_code: geoDataParts[0],
    geo_country_name: geoDataParts[1],
    geo_city: geoDataParts[2],
    geo_timezone: geoDataParts[3]
  };
};
export var getDeviceInfoPayload = function getDeviceInfoPayload() {
  var uaResult = new UAParser().getResult().withFeatureCheck();
  return {
    device_type: uaResult.device.type || 'desktop',
    device_vendor: uaResult.device.vendor,
    device_model: uaResult.device.model,
    os_name: uaResult.os.name,
    os_version: uaResult.os.version,
    browser_name: uaResult.browser.name,
    browser_version_full: uaResult.browser.version,
    browser_version_major: uaResult.browser.major,
    device_cpu_arch: uaResult.cpu.architecture,
    device_cpu_cores: window.navigator.hardwareConcurrency,
    device_memory: window.navigator.deviceMemory
  };
};
export var getServiceInfoPayload = function getServiceInfoPayload() {
  return {
    app_service_name: process.env.NEXT_PUBLIC_SERVICE_NAME,
    app_service_version: process.env.NEXT_PUBLIC_SERVICE_VERSION
  };
};
export var getPageInfoPayload = function getPageInfoPayload() {
  return {
    page_slug: window.location.pathname.endsWith('/') ? window.location.pathname : "".concat(window.location.pathname, "/")
  };
};
export var getCommonPayload = function getCommonPayload() {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getNetworkPayload()), getGeoDataPayload()), getDeviceInfoPayload()), getServiceInfoPayload());
};